import { z } from "zod";

export const ChecklistServicoLiberacaoCadastroSchema = z.object({
    idChecklistServico: z.number().int().optional(),
    ordem: z.coerce.string().nonempty({ message: "A ordem é obrigatória." }),
    descricao: z.string().nonempty({ message: "A descrição é obrigatória." }),
});

export type ChecklistServicoLiberacaoCadastroForm = z.infer<typeof ChecklistServicoLiberacaoCadastroSchema>;

export const defaultChecklistServicoLiberacaoCadastroForm: Partial<ChecklistServicoLiberacaoCadastroForm> = {
    idChecklistServico: undefined,
    ordem: '',
    descricao: '',
};
